import { DocumentsCountBaseValueConverter } from 'General/Resources/ValueConverters/DocumentsCountBase';
export class DocumentsCountValueConverter extends DocumentsCountBaseValueConverter {

}